var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"label"},[_vm._v("商品类目：")]),_c('div',{staticClass:"items"},_vm._l((_vm.computedList),function(item,index){return _c('div',{key:index,class:_vm.selectIndex == index ? 'item item-active' : 'item',on:{"click":function($event){return _vm.change(index)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }